// src/components/ChristmasPartyContactForm.jsx
import { useState } from "react";
import emailjs from "@emailjs/browser";

const ChristmasPartyContactForm = ({ selectedDate, quantity }) => {
  const [formData, setFormData] = useState({
    firstName: "",
    surname: "",
    email: "",
    phone: "",
    eventDate: selectedDate || "",
    partySize: quantity || "",
    notes: "",
  });

  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await emailjs.send(
        "service_vqxihsi",
        "template_ng762jv",
        formData,
        "Hvu_XVUVW0O-QPUEW"
      );
      setMessage("🎄 Your Christmas party enquiry has been sent successfully!");
      setFormData({
        firstName: "",
        surname: "",
        email: "",
        phone: "",
        eventDate: selectedDate || "",
        partySize: quantity || "",
        notes: "",
      });
    } catch (error) {
      setMessage("⚠️ Something went wrong, please try again.");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mt-6 p-6 bg-yellow-50 border border-yellow-400 rounded-xl shadow-inner">
      <h3 className="text-xl font-bold text-yellow-800 mb-2">
        For smaller and larger groups, please contact our team directly
      </h3>
      <p className="text-yellow-700 mb-4">
        Bookings under 6 or over 10 guests on {selectedDate} require manual assistance to ensure we can appropriately seat you — please fill out this form and our team will get back to you.
      </p>

      {message && <p className="text-green-700 font-semibold mb-4">{message}</p>}

      <form onSubmit={handleSubmit} className="space-y-3">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          <input
            type="text"
            name="firstName"
            placeholder="First Name"
            value={formData.firstName}
            onChange={handleChange}
            required
            className="border p-2 rounded w-full"
          />
          <input
            type="text"
            name="surname"
            placeholder="Surname"
            value={formData.surname}
            onChange={handleChange}
            required
            className="border p-2 rounded w-full"
          />
        </div>

        <input
          type="email"
          name="email"
          placeholder="Email"
          value={formData.email}
          onChange={handleChange}
          required
          className="border p-2 rounded w-full"
        />
        <input
          type="tel"
          name="phone"
          placeholder="Phone Number"
          value={formData.phone}
          onChange={handleChange}
          required
          className="border p-2 rounded w-full"
        />

        <input
          type="text"
          name="eventDate"
          value={formData.eventDate}
          onChange={handleChange}
          required
          disabled
          className="border p-2 rounded w-full"
          placeholder="Desired Date"
        />

        <input
          type="number"
          name="partySize"
          value={formData.partySize}
          onChange={handleChange}
          required
          className="border p-2 rounded w-full"
          placeholder="Party Size"
        />

        <textarea
          name="notes"
          placeholder="Additional Notes"
          value={formData.notes}
          onChange={handleChange}
          className="border p-2 rounded w-full h-24"
        />

        <button
          type="submit"
          className={`w-full px-6 py-2 rounded-full text-white transition duration-300 shadow-md ${
            loading
              ? "bg-gray-400 cursor-not-allowed"
              : "bg-green-700 hover:bg-green-800"
          }`}
          disabled={loading}
        >
          {loading ? "Sending..." : "Send Enquiry"}
        </button>
      </form>
    </div>
  );
};

export default ChristmasPartyContactForm;